"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const redux_1 = require("redux");
const redux_devtools_extension_1 = require("redux-devtools-extension");
const reducers_1 = __importDefault(require("./reducers"));
const _actions = __importStar(require("./actions"));
exports.actions = _actions;
const middlewares_1 = require("./middlewares");
const maneger = new middlewares_1.MapManageer();
const enhancer = redux_devtools_extension_1.composeWithDevTools(redux_1.applyMiddleware(maneger.middleware));
const store = redux_1.createStore(reducers_1.default, enhancer);
exports.default = store;
